module.exports = "pegasus_template/assets/empty/header-image.jpg";